var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('searchBar'),_c('div',{staticStyle:{"height":"44px"}}),_c('quickNav'),_c('homeProduct'),_c('div',{staticStyle:{"height":"50px"}}),_c('bottomBar',{attrs:{"active":"/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }